import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { TippyV2 } from "@circle-react/components/shared/TippyV2";

interface HeaderDownloadButtonProps {
  onDownload: () => void;
}

export const HeaderDownloadButton = ({
  onDownload,
}: HeaderDownloadButtonProps) => (
  <TippyV2 content={t("help_widget.tooltip.download_transcript")}>
    <button
      type="button"
      onClick={onDownload}
      className="hover:bg-secondary text-light flex size-6 items-center rounded-full p-1"
    >
      <Icon type="16-download" size={16} />
    </button>
  </TippyV2>
);
